import React from 'react'
import { Input, Label } from 'components';

import styles from './Tabs.scss';


const Tabs = (props) => {
  let classNames = styles.wrapper;
  if(props.theme === 'light'){
    classNames = classNames + ' ' + styles.isLight
  }

  let tabClassNames = "";
  let tabs = props.val.map(function(tab, index){
      tabClassNames = "";
      if(tab.active){
        tabClassNames = tabClassNames + ' ' + styles.isActive
      }

      if(tab.batch)
      {
        tabClassNames = tabClassNames + ' ' + styles.batch
      }
      
      if(props.theme === 'light'){
        tabClassNames = tabClassNames + ' ' + styles.isLight
      }
      return <div onClick={() => props.onTabClicked(index)} key={index} className={tabClassNames}>{tab.name}</div>;
  })



  return (
    <div className={classNames}>
      {tabs}
    </div>
  )
}

export default Tabs



// WEBPACK FOOTER //
// ./src/components/molecules/Tabs/index.js